import { RouterProvider } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/hooks/useAuth";
import { ThemeProvider } from "@/context/ThemeContext";
import { ToastProvider } from "@/components/shared/Toast";
import { FloatingVideoCallWindow, VideoCallProvider } from "@/context/VideoCallContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { FeatureGateProvider } from "@/contexts/FeatureGateContext";
import { SurgicalConsentProvider } from "@/contexts/SurgicalConsentContext";
import { SessionTimeoutGuard } from "@/components/auth/SessionTimeoutGuard";
import { router } from "@/routes";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <AuthProvider>
                    <SettingsProvider>
                        <FeatureGateProvider>
                            <SurgicalConsentProvider>
                                <SessionTimeoutGuard>
                                    <ToastProvider>
                                        <VideoCallProvider navigateToPath={(path) => void router.navigate(path)}>
                                            <RouterProvider router={router} />
                                            <FloatingVideoCallWindow />
                                        </VideoCallProvider>
                                    </ToastProvider>
                                </SessionTimeoutGuard>
                            </SurgicalConsentProvider>
                        </FeatureGateProvider>
                    </SettingsProvider>
                </AuthProvider>
            </ThemeProvider>
        </QueryClientProvider>
    );
}
